// extracted by mini-css-extract-plugin
export default {"card":"media-card_card__K-p6S","content":"media-card_content__U5I5z","title":"media-card_title__6OtOJ","description":"media-card_description__+1fSz","chip":"media-card_chip__b3lze"};